import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  justified: {
    textAlign: 'justify',
  },
  centered: {
    textAlign: 'center',
  },
  videoContainer: {
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
      borderRadius: '6px',
      float: 'right',
      maxWidth: '66%',
    },
    [theme.breakpoints.up('lg')]: {
      background: 'rgba(140, 164, 186, 0.1)',
      margin: theme.spacing(0, 0, 4, 4),
    },
    [theme.breakpoints.down('md')]: {
      float: 'none',
      width: '100%',
      marginBottom: theme.spacing(4),
    },
    '&.videoOnly': {
      float: 'none',
      textAlign: 'center',
      margin: '0 auto',
    },
  },
}))
